<template>
  <div v-if="distributionData" class="flex flex-col gap-8 w-full">
    <div
      v-for="rating in sortedRatings"
      :key="rating.stars"
      class="flex items-center gap-4"
      :aria-label="getAriaLabel(rating)"
      role="img"
    >
      <!-- Rating number -->
      <div class="flex items-center justify-center w-32 whitespace-nowrap">
        <span class="text-caption text-grey-text-subdued">{{ rating.stars }}</span>
        <star-outline-icon :width="16" :height="16" color="#8A8A8F" class="ml-4" />
      </div>

      <!-- Percentage bar -->
      <div class="bg-grey-divider-subdued h-16 w-full rounded-xl">
        <div class="bg-brand h-full rounded-tl-xl rounded-bl-xl" :style="{ width: `${rating.percent}%` }" />
      </div>

      <!-- Rating count -->
      <span class="text-caption text-grey-text-subdued w-24 text-center">{{ rating.count }}</span>
    </div>
  </div>
</template>

<script lang="ts">
import pluralize from 'pluralize';
import StarOutlineIcon from '../../graphics/icons/StarOutlineIcon.vue';

interface DistributionData {
  stars: number;
  count: number;
  percent: number;
}

export default {
  name: 'RatingsDistribution',
  components: { StarOutlineIcon },
  props: {
    distributionData: {
      type: Array,
      required: true,
    },
  },
  computed: {
    sortedRatings(): Array<DistributionData> {
      return [...this.distributionData].sort((a, b) => b.stars - a.stars);
    },
  },
  methods: {
    getAriaLabel(rating: DistributionData): string {
      return `${pluralize('rating', rating.count, true)} with ${rating.stars} ${pluralize('star', rating.stars)}, which is ${rating.percent}% of total ratings.`;
    },
  },
};
</script>
